module.exports = __webpack_public_path__ + "img/dengjie.67f1f202.jpg";